<template>
  <ul class="quest-list">
    <li
      v-for="questProtoId in questProtoIds"
      :key="questProtoId"
    >
      <span class="custom-code">{{questProtoId | getProtoAlias}}</span>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'QuestProtoNameList',

  props: {
    questProtoIds: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped>
.quest-list {
  list-style-type: none;
  padding-left: 0;
}
</style>
